import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetPaymentUseCase } from './GetPaymentConfigUseCase';

export const initializePaymentConfigUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetPaymentUseCase, {
        useClass: GetPaymentUseCase,
    });
};
